<template>
  <div>
    身份证
  </div>
</template>
<script>
import { load, unload, readidcard } from "@/assets/js/TXIdcard.js";
export default {
  name: '',
  data() {
    return {
      //
    };
  },
  created() {
    //
  },
  mounted() {
    //
    load(this.onIdCardResult);
    // this.in = setInterval(function () {
    readidcard();
    // }, 1000);
  },
  methods: {
    onIdCardResult(data) {
      // console.log('111', data)
      let res = JSON.parse(data);
      //readidcard();
      if (res.ret != 0) {
        //  console.log("读卡失败请重刷")
      } else {
        console.log(res.data);
        // res.data.age = this.getAgeByIdCard(res.data.Birthday);
        if (this.input != "") {
          this.ruleForm.name = res.data.Name;
          this.ruleForm.age = this.getAgeByIdCard(res.data.Birthday);
          this.ruleForm.identity = res.data.IDCardNo;
          this.enter();
        }
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>